export default {"src":"https://web.cdn.greenlight.com/2.1147.0/_next/static/media/menu-icon.92c04760.svg","height":18,"width":20,"blurWidth":0,"blurHeight":0};